// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-pastel {
  width: 90%;
  margin: 0 auto;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 0;
}

.card-pastel__wrapper {
  width: 100%;
  margin: 16px auto;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(270px, 1fr));
  justify-content: center;
  justify-items: center;
  align-items: stretch;
  gap: 20px;
  list-style: none;
  padding: 0;
}

.card-pastel__block-info {
  width: 90%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin: 10px;
  gap: 10px;
}

.card-pastel__name {
  font-family: Oswald-Light, sans-serif;
  font-size: 0.6em;
  font-weight: 600;
  padding: 6px 0;
  text-align: start;
}

.card-pastel__buttonGoBack {
  font-family: Oswald-Light, sans-serif;
  font-size: 0.6em;
  font-weight: 300;
  text-decoration: none;
  padding: 6px;
  border: 1px solid #5e5d5b;
}
.card-pastel__button {
  width: 50%;
  font-family: Oswald-Light, sans-serif;
  font-size: 0.6em;
  font-weight: 300;
  text-decoration: none;
  padding: 10px;
  border: 1px solid #5e5d5b;
}

@media screen and (max-width: 769px) {
  .card-pastel__block-info {
    width: 90%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    margin-left: 10px;
    gap: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/CardsPastel/CardsPastel.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,cAAc;EACd,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,4DAA4D;EAC5D,uBAAuB;EACvB,qBAAqB;EACrB,oBAAoB;EACpB,SAAS;EACT,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE;IACE,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB,iBAAiB;IACjB,SAAS;EACX;AACF","sourcesContent":[".card-pastel {\r\n  width: 90%;\r\n  margin: 0 auto;\r\n  flex-grow: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  padding: 60px 0;\r\n}\r\n\r\n.card-pastel__wrapper {\r\n  width: 100%;\r\n  margin: 16px auto;\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(270px, 1fr));\r\n  justify-content: center;\r\n  justify-items: center;\r\n  align-items: stretch;\r\n  gap: 20px;\r\n  list-style: none;\r\n  padding: 0;\r\n}\r\n\r\n.card-pastel__block-info {\r\n  width: 90%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-start;\r\n  align-items: flex-start;\r\n  margin: 10px;\r\n  gap: 10px;\r\n}\r\n\r\n.card-pastel__name {\r\n  font-family: Oswald-Light, sans-serif;\r\n  font-size: 0.6em;\r\n  font-weight: 600;\r\n  padding: 6px 0;\r\n  text-align: start;\r\n}\r\n\r\n.card-pastel__buttonGoBack {\r\n  font-family: Oswald-Light, sans-serif;\r\n  font-size: 0.6em;\r\n  font-weight: 300;\r\n  text-decoration: none;\r\n  padding: 6px;\r\n  border: 1px solid #5e5d5b;\r\n}\r\n.card-pastel__button {\r\n  width: 50%;\r\n  font-family: Oswald-Light, sans-serif;\r\n  font-size: 0.6em;\r\n  font-weight: 300;\r\n  text-decoration: none;\r\n  padding: 10px;\r\n  border: 1px solid #5e5d5b;\r\n}\r\n\r\n@media screen and (max-width: 769px) {\r\n  .card-pastel__block-info {\r\n    width: 90%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: flex-start;\r\n    align-items: center;\r\n    margin-left: 10px;\r\n    gap: 10px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
